const CustomMergeFieldContext = React.createContext();

export default CustomMergeFieldContext;
